var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"placeholderScreen flex-align-center",staticStyle:{"color":"aqua"}},[_c('img',{attrs:{"src":require("../../../assets/datascreen/zanwusz.png"),"alt":"","draggable":"false"}})])
}]

export { render, staticRenderFns }